var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "found-error"
  }, [_c('div', {
    staticClass: "found-error__wrapper"
  }, [_c('div', {
    staticClass: "found-error__title"
  }, [_vm._v("\n      Нашли ошибку?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "found-error__subtitle"
  }, [_vm._v("\n      Помогите сделать сайт лучше!\n    ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "33",
      "theme": "white",
      "data-e2e": "found-error-button"
    },
    on: {
      "click": function ($event) {
        return _vm.emit('found', true);
      }
    }
  }, [_vm._v("\n      Сообщить об ошибке\n    ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }